import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const MarkDownImages = ({ msg, replacedText }) => {
  useEffect(() => {}, [msg?.files, replacedText?.length]);
  const ImageRendererAll = ({ src, alt, title }) => {
    if (
      msg?.files !== undefined &&
      msg?.files !== null &&
      msg?.files.length > 0
    ) {
      const imagesrc = msg.files.find((img) => img.name === alt)?.image || src;
      if (imagesrc !== "" && imagesrc.length > 1000) {
        return (
          <img
            src={imagesrc}
            alt={alt}
            title={title}
            className="chat-img-box"
          />
        );
      }
    }
  };

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        ol: ({ children }) => (
          <ol style={{ paddingLeft: "1.5rem", margin: "0" }}>{children}</ol>
        ),
        li: ({ children }) => (
          <li style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {children}
          </li>
        ),
        img: ImageRendererAll,
      }}
      rehypePlugins={[rehypeRaw]}
    >
      {replacedText}
    </ReactMarkdown>
  );
};

export default MarkDownImages;
